import Vue from 'vue';
import Notifications from 'vue-notification';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import { Mixin } from 'gw-js-lib';
import i18n from '@/i18n/i18n';
import router from '@/router/router';
import store from '@/store/store';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import App from './App.vue';

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Notifications);

let defaultLanguage = process.env.VUE_APP_LOCALE;
if (store.state && store.state.course && store.state.course.language) {
  defaultLanguage = store.state.course.language;
  i18n.locale = 'en';
}

Vue.mixin(Mixin);
Mixin.methods.G_init({ 
  store: (field) => {
    return store.state[field];
  }, 
  language: defaultLanguage,
  translate: (key) => {
    return i18n.t(key);
  }
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
extend('required', required);

if (process.env.VUE_APP_SENTRY_ENABLE === 'true') {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_END_POINT,
    environment: process.env.VUE_APP_SENTRY_ENV,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  });
}

const VUE_APP = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
});
VUE_APP.$mount('#app');
Mixin.data().consts.Context.APP = VUE_APP;
